/* unplugin-vue-components disabled */
import Source from './source.vue'
import ViewMore from './view-more.vue'

const __default__ = {
  components: {
    Source, 
    ViewMore
  },
  mixins: [ModelValue(Array)],
  props: {
    sources: {
      type: Array,
      default: () => []
    },
    colsCount: {
      type: Number,
      default: 4
    },
    colWidth: {
      type: String,
      default: '18.3rem'
    },
    loading: {
      type: Boolean,
      required: true
    },
    showAll: {
      type: Boolean,
      default: false
    }
  },
  emits: ['show-all'],
  data(){
    return {
      items: [],
      new_items: [],
      appending: false,
      hide_last: false,
      all_done: false,
    }
  },
  computed: {
    show_skeleton(){
      return this.loading && !this.sources.length
    },
    cols(){
      const elems = this.items.length
      if (elems === 0 || this.all_done) return `repeat(${this.colsCount}, ${this.colWidth})`
      else if (elems === 1) return '1fr'
      else if (elems < this.colsCount) return `repeat(${elems - 1}, ${this.colWidth}) 1fr`
      else return `repeat(${elems}, ${this.colWidth})`
    },
  },
  watch: {
    sources(val, prev) {
      if (this.loading) {
        const diff = val.length - prev.length
        const diff_sources =  val.slice(val.length - diff)
        this.new_items.push(...diff_sources)
        if (!this.appending) this.appendNew()
      }
    },
    cols(){
      if (!this.all_done) return
      this.end()
      if (this.showAll) this.handleShowAll()
    },
    async loading(val){
      if (!val) {
        await this.$nextTick()
        if (this.$el.scrollWidth > this.$el.clientWidth) {
          this.scrollToLeft()
        }
        else this.end()
      }
    },
    showAll(){
      this.handleShowAll()
    }
  },
  mounted() {
    if (this.loading) this.start()
    else this.end()
  },
  methods: {
    handleShowAll(){
      if (this.showAll) this.items.push(this.sources[this.colsCount - 1])
      else this.items.pop()
    },
    start(){
      this.new_items.push(...this.sources)
      this.appendNew()
    },
    end(){
      const has_extra = this.sources.length > this.colsCount
      this.items = this.sources.slice(0, has_extra ? this.colsCount - 1 : this.colsCount)
      this.all_done = true
    },
    appendNew(){
      if (this.new_items.length) {
        this.appending = true
        this.hide_last = true
        this.items.push(this.new_items.shift())
      }
      else this.appending = false
    },
    scrollToRight(){
      this.$el.scrollTo({
        left: this.$el.scrollWidth, 
        behavior: 'smooth',
      })
    },
    scrollToLeft() {
      this.$el.scrollTo({
        left: 0, 
        behavior: 'smooth',
      })
    },
    onScrollEnd(){
      if (this.loading) this.hide_last = false
      else this.end()
    },
    onMounted(){
      if (this.items.length > this.colsCount) this.scrollToRight()
      else this.onScrollEnd()
    },
    onAppend(ev){
      if (ev.propertyName === 'left') {
        this.appendNew()
      }
    },

  }
}

import { useCssVars as _useCssVars } from 'vue'
const __injectCSSVars__ = () => {
_useCssVars(_ctx => ({
  "356ef103-cols": (_ctx.cols),
  "356ef103-colWidth": (_ctx.colWidth)
}))}
const __setup__ = __default__.setup
__default__.setup = __setup__
  ? (props, ctx) => { __injectCSSVars__();return __setup__(props, ctx) }
  : __injectCSSVars__

export default __default__